/** Colaboração sobre a conversa: fixar, ler, atribuir, status, etiquetas, notas. */
import { z } from "zod";
import { LIMITS, conversationStatus, noteVisibility } from "../enums.js";
import { uuid } from "./common.js";

/* ---------- Colaboracao ---------- */
export const pinConversationInput = z.object({
  conversationId: uuid,
  pinned: z.boolean(),
});
export type PinConversationInput = z.infer<typeof pinConversationInput>;

export const markReadInput = z.object({
  conversationId: uuid,
  read: z.boolean(),
});

export const assignConversationInput = z.object({
  conversationId: uuid,
  userId: uuid.nullable(),
  /** Concorrencia otimista: evita ASSIGN_RACE silencioso (docs/07). */
  expectedAssigneeId: uuid.nullable().optional(),
});
export type AssignConversationInput = z.infer<typeof assignConversationInput>;

export const setConversationStatusInput = z.object({
  conversationId: uuid,
  status: conversationStatus,
  reason: z.string().max(200).optional(),
});

export const setConversationLabelsInput = z.object({
  conversationId: uuid,
  labelIds: z.array(uuid).max(20),
});

export const internalNoteInput = z.object({
  conversationId: uuid,
  body: z.string().min(1).max(LIMITS.MESSAGE_TEXT_MAX),
  visibility: noteVisibility.default("team"),
  /** IDs de usuarios mencionados (@). */
  mentions: z.array(uuid).max(20).default([]),
});
export type InternalNoteInput = z.infer<typeof internalNoteInput>;
